import System from './System';

export default System
export { System as Base }
